import { IconButton } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";

function CloseBtn({ onClose }: any) {
  return (
    <IconButton
      edge="end"
      onClick={onClose}
      aria-label="close"
      className="close-btn"
    >
      <GridCloseIcon />
    </IconButton>
  );
}

export default CloseBtn;
